import React, { memo } from "react";

import { formatCurrency } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { getBasePrice, getListingTitle, getSelectedChannels, getSpecsLine } from "../helpers";
import { ListingSceneProps } from "../types";
import AdImage from "./AdImage";
import ChannelTile from "./ChannelTile";

const CHANNEL_ROW_COUNT = 3;

/** Završni pregled: gotov oglas, status objave na odabranim oglasnicima i objava jednim spremanjem. */
const PreviewScene: React.FC<ListingSceneProps> = ({ formValues }) => {
  const channels = getSelectedChannels(formValues).slice(0, CHANNEL_ROW_COUNT);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-3">
          <div className="relative">
            <AdImage formValues={formValues} className="h-[10rem] rounded-md" />
            <span className="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-500 text-[0.6rem] font-semibold text-white">
              <span className="w-1.5 h-1.5 rounded-full bg-white" />
              Objavljeno
            </span>
          </div>
          <div className="px-2 pt-3">
            <div className="text-sm font-bold text-slate-800 truncate">{getListingTitle(formValues)}</div>
            <div className="mt-1 text-base font-bold text-red-600">{formatCurrency.format(getBasePrice(formValues))}</div>
            <div className="mt-1 text-[0.65rem] text-slate-400 truncate">{getSpecsLine(formValues)}</div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Status objave</div>
          <div className="mt-3 space-y-2">
            {channels.map((channel) => (
              <div key={channel.id} className="flex items-center gap-2">
                <ChannelTile code={channel.code} name={channel.name} />
                <span className="flex-1 min-w-0 text-[0.7rem] font-medium text-slate-700 truncate">{channel.name}</span>
                <span className="px-1.5 py-0.5 rounded-full bg-emerald-100 text-[0.6rem] font-semibold text-emerald-700">Objavljeno</span>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Objava jednim spremanjem"
          subtitle="Na svim odabranim oglasnicima"
          iconClassName="bg-emerald-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#047857" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(PreviewScene);
